<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop12" :series="switchDataTop12" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop13" :series="switchDataTop13" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop14" :series="switchDataTop14" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop15" :series="switchDataTop15" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-XL">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
          <SwitchStatus class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
          <SwitchStatus class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
          <SwitchStatus class="switch-item" :title="switchTitleTop25" :series="switchDataTop25" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop26" :series="switchDataTop26" />
          <SwitchStatus class="switch-item" :title="switchTitleTop27" :series="switchDataTop27" />
          <SwitchStatus class="switch-item" :title="switchTitleTop28" :series="switchDataTop28" />
        </div>
        <div class="column-line-XS">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleBottom2" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleBottom21" :series="switchDataBottom21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleBottom22" :series="switchDataBottom22" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-XL">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
          <SwitchStatus class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
          <SwitchStatus class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
          <SwitchStatus class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
          <SwitchStatus class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
          <SwitchStatus class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
        </div>
        <div class="column-line-XS">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleBottom3" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleBottom31" :series="switchDataBottom31" />
          <SwitchStatusValue class="switch-item" :title="switchTitleBottom32" :series="switchDataBottom32" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop41" :series="switchDataTop41" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop42" :series="switchDataTop42" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop43" :series="switchDataTop43" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop44" :series="switchDataTop44" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop45" :series="switchDataTop45" />
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/station_anchorSaddle.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationIdList: "",
      stationName: "",
      stationIndex: "",
      stationVentNameFix: "",
      sideName: "",
      stationTypeName: "",

      exitGasClampListDict: {
        "1出口": ["A1", "A2"],
      },

      switchDataTop11: null,
      switchDataTop12: null,
      switchDataTop13: null,
      switchDataTop14: null,
      switchDataTop15: null,

      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,
      switchDataTop25: null,
      switchDataTop26: null,
      switchDataTop27: null,
      switchDataTop28: null,

      switchDataBottom21: null,
      switchDataBottom22: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,

      switchDataBottom31: null,
      switchDataBottom32: null,

      switchDataTop41: null,
      switchDataTop42: null,
      switchDataTop43: null,
      switchDataTop44: null,
      switchDataTop45: null,

      deviceList: [],
    };
  },
  computed: {
    columnTitleTop1: function () {
      return this.sideName + "南侧" + this.stationTypeName + "温湿度";
    },
    columnTitleTop2: function () {
      return this.sideName + "南侧" + this.stationTypeName + "状态";
    },
    columnTitleBottom2: function () {
      return this.sideName + "南侧" + this.stationTypeName + "设定";
    },
    columnTitleTop3: function () {
      return this.sideName + "北侧" + this.stationTypeName + "状态";
    },
    columnTitleBottom3: function () {
      return this.sideName + "北侧" + this.stationTypeName + "设定";
    },
    columnTitleTop4: function () {
      return this.sideName + "北侧" + this.stationTypeName + "温湿度";
    },

    switchTitleTop11: function () {
      return "传感器1";
    },
    switchTitleTop12: function () {
      return "传感器2";
    },
    switchTitleTop13: function () {
      return "传感器3";
    },
    switchTitleTop14: function () {
      return "传感器4";
    },
    switchTitleTop15: function () {
      return "传感器5";
    },

    switchTitleTop21: function () {
      return "除湿机";
    },
    switchTitleTop22: function () {
      return "除湿机";
    },
    switchTitleTop23: function () {
      return "一级除湿";
    },
    switchTitleTop24: function () {
      return "二级除湿";
    },
    switchTitleTop25: function () {
      return "风机";
    },
    switchTitleTop26: function () {
      return "风机";
    },
    switchTitleTop27: function () {
      return "远程控制";
    },
    switchTitleTop28: function () {
      return "供电";
    },

    switchTitleBottom21: function () {
      return "一级启停设定";
    },
    switchTitleBottom22: function () {
      return "二级启停设定";
    },

    switchTitleTop31: function () {
      return "除湿机";
    },
    switchTitleTop32: function () {
      return "除湿机";
    },
    switchTitleTop33: function () {
      return "一级除湿";
    },
    switchTitleTop34: function () {
      return "二级除湿";
    },
    switchTitleTop35: function () {
      return "风机";
    },
    switchTitleTop36: function () {
      return "风机";
    },
    switchTitleTop37: function () {
      return "远程控制";
    },
    switchTitleTop38: function () {
      return "供电";
    },

    switchTitleBottom31: function () {
      return "一级启停设定";
    },
    switchTitleBottom32: function () {
      return "二级启停设定";
    },

    switchTitleTop41: function () {
      return "传感器1";
    },
    switchTitleTop42: function () {
      return "传感器2";
    },
    switchTitleTop43: function () {
      return "传感器3";
    },
    switchTitleTop44: function () {
      return "传感器4";
    },
    switchTitleTop45: function () {
      return "传感器5";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    assembleExitGasClamp(exitName) {
      let gasClampName = "";
      if (exitName && this.exitGasClampListDict[exitName]) {
        let gasClampList = this.exitGasClampListDict[exitName];
        for (let gasClamp of gasClampList) {
          if (gasClampName !== "") {
            gasClampName += ", ";
          }
          gasClampName += gasClamp;
        }
      }

      let result = exitName + "连接气夹: " + gasClampName;
      return result;
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();

      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationIdList = configJson[routerName].stationIdList;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
      this.sideName = configJson[routerName].sideName;
      this.stationTypeName = configJson[routerName].stationTypeName;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      let requestList = [];
      for (let stationId of this.stationIdList) {
        requestList.push(this.getCurrentData(stationId));
      }

      let currentData = {};
      this.$http.all(requestList).then(
        this.$http.spread((...resList) => {
          for (let res of resList) {
            Object.assign(currentData, res.data);
          }

          setTimeout(() => {
            this.loadingData = false;
          }, 500);

          const switchIdTop11T = this.findDeviceId("南侧" + this.switchTitleTop11 + "温度");
          const switchIdTop11H = this.findDeviceId("南侧" + this.switchTitleTop11 + "湿度");
          const switchIdTop11A = this.findDeviceId("南侧" + this.switchTitleTop11 + "含湿量");
          const switchIdTop12T = this.findDeviceId("南侧" + this.switchTitleTop12 + "温度");
          const switchIdTop12H = this.findDeviceId("南侧" + this.switchTitleTop12 + "湿度");
          const switchIdTop12A = this.findDeviceId("南侧" + this.switchTitleTop12 + "含湿量");
          const switchIdTop13T = this.findDeviceId("南侧" + this.switchTitleTop13 + "温度");
          const switchIdTop13H = this.findDeviceId("南侧" + this.switchTitleTop13 + "湿度");
          const switchIdTop13A = this.findDeviceId("南侧" + this.switchTitleTop13 + "含湿量");
          const switchIdTop14T = this.findDeviceId("南侧" + this.switchTitleTop14 + "温度");
          const switchIdTop14H = this.findDeviceId("南侧" + this.switchTitleTop14 + "湿度");
          const switchIdTop14A = this.findDeviceId("南侧" + this.switchTitleTop14 + "含湿量");
          const switchIdTop15T = this.findDeviceId("南侧" + this.switchTitleTop15 + "温度");
          const switchIdTop15H = this.findDeviceId("南侧" + this.switchTitleTop15 + "湿度");
          const switchIdTop15A = this.findDeviceId("南侧" + this.switchTitleTop15 + "含湿量");

          this.switchDataTop11 = [
            {
              data: currentData[switchIdTop11T].value,
              isError: currentData[switchIdTop11T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop11H].value,
              isError: currentData[switchIdTop11H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop11A].value,
              isError: currentData[switchIdTop11A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop12 = [
            {
              data: currentData[switchIdTop12T].value,
              isError: currentData[switchIdTop12T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop12H].value,
              isError: currentData[switchIdTop12H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop12A].value,
              isError: currentData[switchIdTop12A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop13 = [
            {
              data: currentData[switchIdTop13T].value,
              isError: currentData[switchIdTop13T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop13H].value,
              isError: currentData[switchIdTop13H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop13A].value,
              isError: currentData[switchIdTop13A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop14 = [
            {
              data: currentData[switchIdTop14T].value,
              isError: currentData[switchIdTop14T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop14H].value,
              isError: currentData[switchIdTop14H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop14A].value,
              isError: currentData[switchIdTop14A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop15 = [
            {
              data: currentData[switchIdTop15T].value,
              isError: currentData[switchIdTop15T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop15H].value,
              isError: currentData[switchIdTop15H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop15A].value,
              isError: currentData[switchIdTop15A].errorLevel,
              unit: "g/kg",
            },
          ];

          const switchIdTop21 = this.findDeviceId("南侧" + this.switchTitleTop21 + "运行");
          const switchIdTop21B = this.findDeviceId("南侧" + this.switchTitleTop21 + "报警");
          const switchIdTop22 = this.findDeviceId("南侧" + this.switchTitleTop22 + "运行时间");
          const switchIdTop23 = this.findDeviceId("南侧" + this.switchTitleTop23);
          const switchIdTop24 = this.findDeviceId("南侧" + this.switchTitleTop24);
          const switchIdTop25 = this.findDeviceId("南侧" + this.switchTitleTop25 + "运行");
          const switchIdTop25B = this.findDeviceId("南侧" + this.switchTitleTop25 + "报警");
          const switchIdTop26 = this.findDeviceId("南侧" + this.switchTitleTop26 + "运行时间");
          const switchIdTop27 = this.findDeviceId("南侧" + this.switchTitleTop27);
          const switchIdTop28 = this.findDeviceId("南侧" + this.switchTitleTop28 + "监测");
          this.switchDataTop21 = [
            {
              data: currentData[switchIdTop21B].value,
              isError: currentData[switchIdTop21B].errorLevel,
              isZh: true,
              textOn: "报警",
            },
            {
              data: currentData[switchIdTop21].value,
              isError: currentData[switchIdTop21].errorLevel,
            },
          ];
          this.switchDataTop22 = {
            data: currentData[switchIdTop22].value,
            isError: currentData[switchIdTop22].errorLevel,
            isRunningTime: true,
          };
          this.switchDataTop23 = {
            data: currentData[switchIdTop23].value,
            isError: currentData[switchIdTop23].errorLevel,
          };
          this.switchDataTop24 = {
            data: currentData[switchIdTop24].value,
            isError: currentData[switchIdTop24].errorLevel,
          };
          this.switchDataTop25 = [
            {
              data: currentData[switchIdTop25B].value,
              isError: currentData[switchIdTop25B].errorLevel,
              isZh: true,
              textOn: "报警",
            },
            {
              data: currentData[switchIdTop25].value,
              isError: currentData[switchIdTop25].errorLevel,
            },
          ];
          this.switchDataTop26 = {
            data: currentData[switchIdTop26].value,
            isError: currentData[switchIdTop26].errorLevel,
            isRunningTime: true,
          };
          this.switchDataTop27 = {
            data: currentData[switchIdTop27].value,
            isError: currentData[switchIdTop27].errorLevel,
            textOff: "就地",
            textOn: "远程",
          };
          this.switchDataTop28 = {
            data: this.revertSwitchValue(currentData[switchIdTop28].value),
            isError: currentData[switchIdTop28].errorLevel,
            textOn: "停电",
            isZh: true,
          };

          const switchIdBottom21 = this.findDeviceId("南侧" + "除湿" + this.switchTitleBottom21.replace("启停设定", "启动设定"));
          const switchIdBottom21B = this.findDeviceId("南侧" + "除湿" + this.switchTitleBottom21.replace("启停设定", "停止设定"));
          const switchIdBottom22 = this.findDeviceId("南侧" + "除湿" + this.switchTitleBottom22.replace("启停设定", "启动设定"));
          const switchIdBottom22B = this.findDeviceId("南侧" + "除湿" + this.switchTitleBottom22.replace("启停设定", "停止设定"));
          this.switchDataBottom21 = [
            {
              data: currentData[switchIdBottom21].value,
              isError: currentData[switchIdBottom21].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdBottom21B].value,
              isError: currentData[switchIdBottom21B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataBottom22 = [
            {
              data: currentData[switchIdBottom22].value,
              isError: currentData[switchIdBottom22].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdBottom22B].value,
              isError: currentData[switchIdBottom22B].errorLevel,
              unit: "%",
            },
          ];

          const switchIdTop31 = this.findDeviceId("北侧" + this.switchTitleTop31 + "运行");
          const switchIdTop31B = this.findDeviceId("北侧" + this.switchTitleTop31 + "报警");
          const switchIdTop32 = this.findDeviceId("北侧" + this.switchTitleTop32 + "运行时间");
          const switchIdTop33 = this.findDeviceId("北侧" + this.switchTitleTop33);
          const switchIdTop34 = this.findDeviceId("北侧" + this.switchTitleTop34);
          const switchIdTop35 = this.findDeviceId("北侧" + this.switchTitleTop35 + "运行");
          const switchIdTop35B = this.findDeviceId("北侧" + this.switchTitleTop35 + "报警");
          const switchIdTop36 = this.findDeviceId("北侧" + this.switchTitleTop36 + "运行时间");
          const switchIdTop37 = this.findDeviceId("北侧" + this.switchTitleTop37);
          const switchIdTop38 = this.findDeviceId("北侧" + this.switchTitleTop38 + "监测");
          this.switchDataTop31 = [
            {
              data: currentData[switchIdTop31B].value,
              isError: currentData[switchIdTop31B].errorLevel,
              isZh: true,
              textOn: "报警",
            },
            {
              data: currentData[switchIdTop31].value,
              isError: currentData[switchIdTop31].errorLevel,
            },
          ];
          this.switchDataTop32 = {
            data: currentData[switchIdTop32].value,
            isError: currentData[switchIdTop32].errorLevel,
            isRunningTime: true,
          };
          this.switchDataTop33 = {
            data: currentData[switchIdTop33].value,
            isError: currentData[switchIdTop33].errorLevel,
          };
          this.switchDataTop34 = {
            data: currentData[switchIdTop34].value,
            isError: currentData[switchIdTop34].errorLevel,
          };
          this.switchDataTop35 = [
            {
              data: currentData[switchIdTop35B].value,
              isError: currentData[switchIdTop35B].errorLevel,
              isZh: true,
              textOn: "报警",
            },
            {
              data: currentData[switchIdTop35].value,
              isError: currentData[switchIdTop35].errorLevel,
            },
          ];
          this.switchDataTop36 = {
            data: currentData[switchIdTop36].value,
            isError: currentData[switchIdTop36].errorLevel,
            isRunningTime: true,
          };
          this.switchDataTop37 = {
            data: currentData[switchIdTop37].value,
            isError: currentData[switchIdTop37].errorLevel,
            textOff: "就地",
            textOn: "远程",
          };
          this.switchDataTop38 = {
            data: this.revertSwitchValue(currentData[switchIdTop38].value),
            isError: currentData[switchIdTop38].errorLevel,
            textOn: "停电",
            isZh: true,
          };

          const switchIdBottom31 = this.findDeviceId("北侧" + "除湿" + this.switchTitleBottom31.replace("启停设定", "启动设定"));
          const switchIdBottom31B = this.findDeviceId("北侧" + "除湿" + this.switchTitleBottom31.replace("启停设定", "停止设定"));
          const switchIdBottom32 = this.findDeviceId("北侧" + "除湿" + this.switchTitleBottom32.replace("启停设定", "启动设定"));
          const switchIdBottom32B = this.findDeviceId("北侧" + "除湿" + this.switchTitleBottom32.replace("启停设定", "停止设定"));
          this.switchDataBottom31 = [
            {
              data: currentData[switchIdBottom31].value,
              isError: currentData[switchIdBottom31].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdBottom31B].value,
              isError: currentData[switchIdBottom31B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataBottom32 = [
            {
              data: currentData[switchIdBottom32].value,
              isError: currentData[switchIdBottom32].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdBottom32B].value,
              isError: currentData[switchIdBottom32B].errorLevel,
              unit: "%",
            },
          ];

          const switchIdTop41T = this.findDeviceId("北侧" + this.switchTitleTop41 + "温度");
          const switchIdTop41H = this.findDeviceId("北侧" + this.switchTitleTop41 + "湿度");
          const switchIdTop41A = this.findDeviceId("北侧" + this.switchTitleTop41 + "含湿量");
          const switchIdTop42T = this.findDeviceId("北侧" + this.switchTitleTop42 + "温度");
          const switchIdTop42H = this.findDeviceId("北侧" + this.switchTitleTop42 + "湿度");
          const switchIdTop42A = this.findDeviceId("北侧" + this.switchTitleTop42 + "含湿量");
          const switchIdTop43T = this.findDeviceId("北侧" + this.switchTitleTop43 + "温度");
          const switchIdTop43H = this.findDeviceId("北侧" + this.switchTitleTop43 + "湿度");
          const switchIdTop43A = this.findDeviceId("北侧" + this.switchTitleTop43 + "含湿量");
          const switchIdTop44T = this.findDeviceId("北侧" + this.switchTitleTop44 + "温度");
          const switchIdTop44H = this.findDeviceId("北侧" + this.switchTitleTop44 + "湿度");
          const switchIdTop44A = this.findDeviceId("北侧" + this.switchTitleTop44 + "含湿量");
          const switchIdTop45T = this.findDeviceId("北侧" + this.switchTitleTop45 + "温度");
          const switchIdTop45H = this.findDeviceId("北侧" + this.switchTitleTop45 + "湿度");
          const switchIdTop45A = this.findDeviceId("北侧" + this.switchTitleTop45 + "含湿量");

          this.switchDataTop41 = [
            {
              data: currentData[switchIdTop41T].value,
              isError: currentData[switchIdTop41T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop41H].value,
              isError: currentData[switchIdTop41H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop41A].value,
              isError: currentData[switchIdTop41A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop42 = [
            {
              data: currentData[switchIdTop42T].value,
              isError: currentData[switchIdTop42T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop42H].value,
              isError: currentData[switchIdTop42H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop42A].value,
              isError: currentData[switchIdTop42A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop43 = [
            {
              data: currentData[switchIdTop43T].value,
              isError: currentData[switchIdTop43T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop43H].value,
              isError: currentData[switchIdTop43H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop43A].value,
              isError: currentData[switchIdTop43A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop44 = [
            {
              data: currentData[switchIdTop44T].value,
              isError: currentData[switchIdTop44T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop44H].value,
              isError: currentData[switchIdTop44H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop44A].value,
              isError: currentData[switchIdTop44A].errorLevel,
              unit: "g/kg",
            },
          ];
          this.switchDataTop45 = [
            {
              data: currentData[switchIdTop45T].value,
              isError: currentData[switchIdTop45T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop45H].value,
              isError: currentData[switchIdTop45H].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop45A].value,
              isError: currentData[switchIdTop45A].errorLevel,
              unit: "g/kg",
            },
          ];
        })
      );
    },

    revertSwitchValue(input) {
      if (input === 0) {
        return 1;
      } else if (input === 1) {
        return 0;
      } else {
        return input;
      }
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-L {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 380px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-S {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 250px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XL {
    width: 100%;
    height: calc(75% - 7px);
    min-height: 430px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XS {
    width: 100%;
    height: calc(25% - 7px);
    min-height: 200px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-full {
    height: 100%;
    min-height: 635px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 4 - 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .switch-in-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin-bottom: 5px;
  }

  .main-column-multi-line {
    width: calc(100% / 4 - 10px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item-sub-title {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .tooltip-slot {
    line-height: 1.4;
  }
}
</style>
